import styled from "styled-components/macro";
import type { PIMProduct } from "../../../../../types/types.PIM";
import { ExternalLinksPortfolioAssets } from "./ExternalLinksPortfolioAssets";
import type { DataMutate } from "../../../../../types/types";
import { DocumentsOrDigitalMediaTable } from "../DocumentsOrDigitalMediaTable/DocumentsOrDigitalMediaTable";
import { t } from "i18next";

const PortfolioAssetsContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const PortfolioAssets = ({
  product,
  fetchProductData,
  isShowTableWithBulkAction = false,
  isShowGridAssetWithBulkAction = false,
  documentType,
}: {
  product: PIMProduct;
  fetchProductData: DataMutate<PIMProduct>;
  isShowTableWithBulkAction?: boolean;
  isShowGridAssetWithBulkAction?: boolean;
  documentType?: string;
}) => {
  return (
    <PortfolioAssetsContainer>
      <DocumentsOrDigitalMediaTable
        fetchProductData={fetchProductData}
        title={t("Documents")}
        key={"Documents"}
        product={product}
        replaceProductId={() => Promise.resolve()}
        isOutsideLogin={true}
        isShowTableWithBulkAction={isShowTableWithBulkAction}
        isShowGridAssetWithBulkAction={isShowGridAssetWithBulkAction}
        documentType={documentType}
      />
      {/* very confusing, but this actually only displays one or the other based on the title */}
      <DocumentsOrDigitalMediaTable
        fetchProductData={fetchProductData}
        title={t("Digital Media")}
        key={"Digital Media"}
        product={product}
        replaceProductId={() => Promise.resolve()}
        isOutsideLogin={true}
        isShowTableWithBulkAction={isShowTableWithBulkAction}
        isShowGridAssetWithBulkAction={isShowGridAssetWithBulkAction}
        documentType={documentType}
      />
      <ExternalLinksPortfolioAssets product_id={product.id} />
    </PortfolioAssetsContainer>
  );
};
